import { toQueryString } from './to-query-string'
import axios from 'axios'
import { transformResponse } from './transform-response'

export function createServices(baseUrl, options) {
    const connection = options?.connection ?? axios
    return {
        list: async (params = {}) => {
            const response = await connection.get(`${baseUrl}/index`, {
                params: toQueryString(params),
            })
            return transformResponse(response)
        },
        get: async (id) => {
            const response = await connection.get(`${baseUrl}/view`, { params: { id } })
            return transformResponse(response, 'data')
        },
        create: async (values) => {
            if (options?.validate) {
                const errors = options.validate(values, true)
                if (errors) {
                    return {
                        success: false,
                        message: 'Hay datos incorrectos',
                        data: null,
                        errors,
                        code: 400,
                    }
                }
            }
            const payload = options?.transform ? await options.transform(values, true) : values
            const response = await connection.post(`${baseUrl}/create`, payload)
            return transformResponse(response, 'data')
        },
        update: async (id, values) => {
            if (options?.validate) {
                const errors = options.validate(values, false)
                if (errors) {
                    return {
                        success: false,
                        message: 'Hay datos incorrectos',
                        data: null,
                        errors,
                        code: 400,
                    }
                }
            }
            const payload = options?.transform ? await options.transform(values, false) : values
            const response = await connection.post(`${baseUrl}/update`, payload, {
                params: { id },
            })
            return transformResponse(response, 'data')
        },
        delete: async (id) => {
            const response = await connection.post(`${baseUrl}/delete`, {}, { params: { id } })
            return transformResponse(response, 'data')
        },
    }
}
